import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import style from './block.module.scss';

const TwoColumns = () => (
    <BlockWrapper.ChildrenBlocks
        className={style.block}
        gutenbergEditorConfig={{
            orientation: 'horizontal',
            allowedBlocks: ['core/paragraph'],
            template: [['core/paragraph'], ['core/paragraph']],
        }}
    />
);

export default defineBlock({
    Block: TwoColumns,
    setup: {
        title: 'Titre & contenu - 2 colonnes ',
        parent: ['smartfire/title-content'],
    },
});
